import { StandardEvents } from '@shopify/events';

class SeafloProductGallery extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.addEventListener('click', (event) => {
      const target = event.target.closest('button');
      if (!target) return;
      const dialog = this.querySelector('dialog');
      if (target.hasAttribute('data-sfd-photo')) {
        this.querySelector('[data-sfd-main]').src = target.dataset.sfdPhoto;
        this.querySelector('[data-sfd-large]').src = target.dataset.sfdPhoto;
        this.querySelectorAll('[data-sfd-photo]').forEach(button => button.setAttribute('aria-pressed', String(button === target)));
      } else if (target.hasAttribute('data-sfd-zoom')) {
        dialog.showModal();
      } else if (target.hasAttribute('data-sfd-close')) {
        dialog.close();
      }
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}

class SeafloProductDescription extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    document.addEventListener(StandardEvents.productSelect, async (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, dialog')) return;
      try {
        const { detail } = await event.promise;
        const content = detail?.html?.querySelector('template[data-sfd-description]');
        if (!content || !this.isConnected) return;
        this.querySelector('[data-sfd-description-body]').replaceChildren(content.content.cloneNode(true));
        this.hidden = !content.content.textContent.trim();
      } catch (error) {
        if (error?.name !== 'AbortError') console.warn('Product description could not update.', error);
      }
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}

if (!customElements.get('sfd-product-gallery')) customElements.define('sfd-product-gallery', SeafloProductGallery);
if (!customElements.get('sfd-product-description')) customElements.define('sfd-product-description', SeafloProductDescription);
